<template>
	<div id="body">
		<div class="overlay">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<div class="page-title wow bounceInLeft animated" ata-wow-delay="0.4s">
							<h1>{{home}}</h1></div>
					</div>
					<div class="col-md-6 col-sm-6">
						<ul class="page-breadcrumb wow bounceInRight animated" ata-wow-delay="0.4s">
							<li>
								<router-link to="/index">{{lang == 1 ? '首页' : 'Home'}}</router-link>
							</li>
							<li class="active">
								<router-link to="/optinion">{{home}}</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="page-seperate"></div>
		<div class="clearfix"></div>
		<!-- Blog & Sidebar Section -->
		<div id="content">
			<section class="blog-section">
				<div class="container">
					<div class="row">
						<!--Blog Section-->
						<div class="col-md-8 col-sm-7col-xs-12">
							<article id="post-221" class="post post-content-area wow fadeInDown animated post-221 page type-page status-publish hentry" data-wow-delay="0.4s">
								<div class="post-content">
									<div class="entry-content">
										<div class="dem-poll-shortcode" v-if="!complete && list.length > 0">
											<!--democracy-->
											<div class="democracy" v-for="(item,index) in list">
												<strong class="dem-poll-title">
													<span style="color: red;margin-right: 5px;">*</span>{{index+1}}.  {{item.title}}
												</strong>
												<div class="dem-screen vote" v-if="item.type == 1">
													<!--单选-->
													<ul class="dem-vote">
														<li v-for="(val,ind) in item.options">
															<label class="dem__radio_label">
																<input class="dem__radio" :name="index" type="radio" :value="val.option_id" :disabled="complete"><span class="dem__spot"></span> {{val.title}}
															</label>
														</li>
													</ul>
												</div>
												<div class="dem-screen vote" v-if="item.type == 2">
													<!--多选-->
													<ul class="dem-vote">
														<li v-for="(val,ind) in item.options">
															<label class="dem__radio_label">
																<input class="dem__checkbox" :name="index" type="checkbox" :value="val.option_id" :disabled="complete"><span class="dem__spot"></span> {{val.title}}
															</label>
														</li>
													</ul>
												</div>
												<div class="dem-screen vote" v-if="item.type == 3">
													<!--单项填空-->
													<ul class="dem-vote">
														<li>
															<label class="dem__radio_label">
																<input class="dem__input" type="text" value="" :disabled="complete">
															</label>
														</li>
													</ul>
												</div>
												<div class="dem-screen vote" v-if="item.type == 4">
													<!--多项填空-->
													<ul class="dem-vote">
														<li v-for="(val,ind) in item.config">
															<label class="dem__radio_label">
																<input class="dem__input" :name="index" type="text" :disabled="complete">
															</label>
														</li>
													</ul>
												</div>
												<div class="dem-screen vote" v-if="item.type == 5">
													<!--评价-->
													<div style="display: flex;align-items: center;font-weight: bold;font-size: 1.1em;">
														<span>{{lang == 1 ? '很不满意' : 'very disgruntled'}}</span>
														<van-rate style="margin: 0 10px;" v-model="item.reta" :size="25" color="#ffd21e" void-icon="star" void-color="#eee" />
														<span>{{lang == 1 ? '很满意' : 'very satisfied'}}</span>
													</div>
													<textarea class="reta-textarea" style="margin: 0.5rem auto;" maxlength="500" :placeholder="lang == 1 ? '请写下你的评价' : 'Please write down your comments'"></textarea>
												</div>
												<div class="dem-screen vote" v-if="item.type == 6">
													<!--时间-->
													<ul class="dem-vote">
														<li>
															<label class="dem__radio_label" style="position: relative;">
																<i class="glyphicon glyphicon-calendar" aria-hidden="true" style="position: absolute;left: 0.5em;top: 50%;transform: translateY(-50%);"></i>
																<input :id="'time' + index" class="dem__time" type="text" style="padding-left: 2em;" :disabled="complete">
															</label>
														</li>
													</ul>
												</div>
											</div>
											<div class="dem-bottom">
												<div class="dem-vote-button"><input class="dem-button" type="button" value="VOTE" data-dem-act="vote" @click="onSubmitTopic"></div>
											</div>
											<!--democracy-->
										</div>
										<div class="dem-poll-shortcode" v-if="complete">
											<div class="complete">{{lang == 1 ? '已完成' : 'the Questionnaire has been accomplished'}}</div>
										</div>
										<div class="dem-poll-shortcode" v-if="list.length == 0">
											<div class="complete">
												新的问卷调查即将开始
												<p style="color: red;line-height: 1;">New questionnaire coming soon</p>
											</div>
										</div>
									</div>
								</div>
							</article>

						</div>
						<!--/Blog Section-->
						<!--Sidebar Section-->
						<div class="col-md-4 col-sm-5 col-xs-12">
							<div class="sidebar">
								<aside id="search-1" class="widget widget_search wow fadeInDown animated" data-wow-delay="0.4s">
									<div class="section-header wow fadeInDown" data-wow-delay="0.4s">
										<h3 class="widget-title">Search</h3></div>
									<form method="get" id="searchform" class="search-form" action="" ref="form">
										<label><input type="search" class="search-field" :placeholder="lang == 1 ? '搜索' : 'Search'" v-model="search" /></label>
										<label><input type="button" class="search-submit" :value="lang == 1 ? '搜索' : 'Search'" @click="onSubmit"></label>
									</form>
								</aside>
								<aside id="recent-posts-1" class="widget widget_recent_entries wow fadeInDown animated" data-wow-delay="0.4s">
									<div class="section-header wow fadeInDown" data-wow-delay="0.4s">
										<h3 class="widget-title">{{lang == 1 ? '近期文章' : 'Latest Release' }}</h3></div>
									<ul>
										<li v-for="item in right">
											<router-link :to="{name:'article',params: { id: item.article_id }}">{{item.title}}</router-link>
										</li>
									</ul>

								</aside>
							</div>
						</div>
						<!--Sidebar Section-->
					</div>
				</div>
			</section>
		</div>
		<!-- /Blog & Sidebar Section -->
	</div>
</template>

<script>
	import { getArticle, checkFeedbackStatus, getFeedback, delFeedback, getTopic, addTopicLog } from '../api/api';
	export default {
		data() {
			return {
				loading: false,
				search: '',
				complete: false,
				show: false,
				right: [],
				type: 1,
				answer: '',
				list: [],
				home: ''
			};
		},
		props: ['lang'],
		methods: {
			onGetTopic() {
				let that = this;
				getTopic({
					lang: this.lang,
				}).then(res => {
					if(res.code == 1) {
						res.data.forEach((item) => {
							if(item.type == 1 || item.type == 2) {
								item.options.forEach((val) => {
									val.check = false;
								})
							} else if(item.type == 5) {
								item.reta = 5;
							}
						})
						that.list = res.data;
						setTimeout(() => {
							that.list.forEach((val, ind) => {
								if(val.type == 6) {
									laydate.render({
										elem: '#time' + ind,
										type: 'datetime',
										lang: that.lang == 1 ? 'zh' : 'en'
									});
								}
							})
						}, 300)
					} else {
						that.complete = true;
					}
				})
			},
			onGetData() {
				let that = this;
				getFeedback({

				}).then(res => {
					if(res.code == 1) {
						if(res.data.ip) {
							that.type = res.data.type;
							that.complete = true;
						}
					}
				})
			},
			onRevote() {
				let that = this;
				if(window.confirm('Are you sure you want cancel the votes?')) {
					delFeedback({

					}).then(res => {
						if(res.code == 1) {
							that.$router.go(0);
						}
					})
				} else {
					return false;
				}
			},
			onSubmit() {
				this.$router.push({
					name: 'search',
					params: {
						search: this.search
					}
				})
			},
			onGetArticleRight() {
				let that = this;
				getArticle({
					lang: this.lang,
					page: 1,
					size: 3
				}).then(res => {
					if(res.code == 1) {
						that.right = res.data;
					}
				})
			},
			onSubmitTopic() {
				let that = this;
				let topic_id = [];
				let option_id = [];
				let texts = this.lang == 1 ? '请完成调查问卷后再提交' : 'Please complete the questionnaire before submitting it';
				this.list.forEach((item, index) => {
					if(item.type == 1) {
						let topics = item.topic_id;
						let options = '';
						$(".democracy").eq(index).find('.dem__radio').forEach((val, ind) => {
							if($(".democracy").eq(index).find('.dem__radio').eq(ind).prop('checked') == true) {
								options = $(".democracy").eq(index).find('.dem__radio').eq(ind).val();
							}
						})
						if(topics && options.length > 0) {
							topic_id.push(topics);
							option_id.push(options);
						}
					} else if(item.type == 2) {
						let topics = item.topic_id;
						let options = [];
						$(".democracy").eq(index).find('.dem__checkbox').forEach((val, ind) => {
							if($(".democracy").eq(index).find('.dem__checkbox').eq(ind).prop('checked') == true) {
								options.push($(".democracy").eq(index).find('.dem__checkbox').eq(ind).val());
							}
						})
						if(topics && options.length > 0) {
							topic_id.push(topics);
							option_id.push(options.join(' && '));
						}
					} else if(item.type == 3) {
						let topics = item.topic_id;
						let options = '';
						if($(".democracy").eq(index).find('.dem__input').val() != '') {
							options = $(".democracy").eq(index).find('.dem__input').eq(0).val();
						}
						if(topics && options) {
							topic_id.push(topics);
							option_id.push(options);
						}
					} else if(item.type == 4) {
						let topics = item.topic_id;
						let options = [];
						$(".democracy").eq(index).find('.dem__input').forEach((val, ind) => {
							if($(".democracy").eq(index).find('.dem__input').eq(ind).val() != '') {
								options[ind] = $(".democracy").eq(index).find('.dem__input').eq(ind).val();
							}
						})
						if(topics && options.length > 0 && options.length == item.config) {
							topic_id.push(topics);
							option_id.push(options.join(' && '));
						}
					} else if(item.type == 5) {
						let topics = item.topic_id;
						let options = "";
						let reta = item.reta || 0;
						let textareas = $(".reta-textarea").val();
						options = reta + ' && ' + textareas;
						if(topics && reta && textareas) {
							topic_id.push(topics);
							option_id.push(options);
						}
					} else if(item.type == 6) {
						let topics = item.topic_id;
						let options = $("#time" + index).val();
						if(topics && options) {
							topic_id.push(topics);
							option_id.push(options);
						}
					}
				})
				if(topic_id.length < this.list.length || option_id.length < this.list.length) {
					alert(texts);
					return false;
				}
				option_id.forEach((val, ind) => {
					option_id[ind] = encodeURIComponent(val);
				})
				topic_id = topic_id.join(',');
				option_id = option_id.join(',');
				addTopicLog({
					lang: this.lang,
					topic_id: topic_id,
					option_id: option_id
				}).then(res => {
					if(res.code == 1) {
						alert('ok');
						that.complete = true;
					}
				})
			},
		},
		created() {
			let that = this;
			this.onGetTopic();
			this.onGetData();
			this.onGetArticleRight();
		},
		mounted() {
			this.home = $(".menu-item.active a").text();
		}
	};
</script>

<style scoped="scoped">
	.complete {
		text-align: center;
		line-height: 100px;
		font-size: 28px;
		font-weight: bold;
	}
	
	.democracy:after {
		content: '';
		display: table;
		clear: both
	}
	
	.democracy ul li,
	.democracy ul {
		background: none;
		padding: 0;
		margin: 0
	}
	
	.democracy ul li:before {
		display: none
	}
	
	.democracy input[type='radio'],
	.democracy input[type='checkbox'] {
		margin: 0;
		vertical-align: middle
	}
	
	.democracy input[type='radio']:focus,
	.democracy input[type='checkbox']:focus {
		outline: 0
	}
	
	.democracy ul {
		list-style: none !important;
		border: 0 !important
	}
	
	.democracy ul li {
		list-style: none !important
	}
	
	input[type="submit"].dem-button,
	a.dem-button,
	.dem-button {
		position: relative;
		display: inline-block;
		text-decoration: none;
		line-height: 1;
		border: 0;
		margin: 0;
		padding: 0;
		cursor: pointer;
		white-space: nowrap;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none
	}
	
	input[type="submit"].dem-button:focus,
	a.dem-button:focus,
	.dem-button:focus {
		outline: 0
	}
	
	input[type="submit"].dem-button:disabled,
	a.dem-button:disabled,
	.dem-button:disabled {
		opacity: .6;
		cursor: not-allowed
	}
	
	a.dem-button:hover {
		text-decoration: none !important
	}
	
	.democracy {
		position: relative;
		margin: 0 auto
	}
	
	.democracy input[type='radio'],
	.democracy input[type='checkbox'] {
		margin-right: .2em
	}
	
	.dem-screen {
		position: relative;
		line-height: 1.3
	}
	
	.democracy ul.dem-vote {
		margin-bottom: 1em
	}
	
	.democracy ul.dem-vote li {
		padding-bottom: 0;
		margin-bottom: 0
	}
	
	.democracy ul.dem-vote li>* {
		margin-bottom: .6em
	}
	
	.democracy ul.dem-answers li {
		padding-bottom: 1em
	}
	
	.dem-answers .dem-label {
		margin-bottom: .2em;
		line-height: 1.2
	}
	
	.dem-graph {
		position: relative;
		color: #555;
		color: rgba(0, 0, 0, .6);
		box-sizing: content-box;
		width: 100%;
		display: table;
		height: 1.2em;
		line-height: 1.2em
	}
	
	.dem-fill {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		background-color: #7cb4dd
	}
	
	.dem-voted-this .dem-fill {
		background-color: #ffc45a
	}
	
	.dem-votes-txt,
	.dem-percent-txt {
		position: relative;
		display: table-cell;
		padding-left: .3em;
		vertical-align: middle;
		font-size: 90%
	}
	
	.dem-poll-info {
		padding-bottom: 1em
	}
	
	.dem-poll-info:after {
		content: '';
		display: table;
		clear: both
	}
	
	.dem-poll-info>* {
		font-size: 85%;
		display: block;
		float: right;
		clear: both;
		text-align: right;
		opacity: .7;
		line-height: 1.3
	}
	
	.dem-vote label {
		float: none;
		display: block
	}
	
	.dem-results-link {
		display: inline-block;
		line-height: 1;
		margin: .8em 1em
	}
	
	.dem-vote .dem-disabled {
		opacity: .5
	}
	
	.democracy .dem-bottom {
		padding-bottom: 1em
	}
	
	.dem-bottom {
		text-align: center
	}
	
	.dem-bottom:after {
		content: '';
		display: table;
		clear: both
	}
	
	.dem-poll-title {
		display: block;
		margin-bottom: 0.5em;
		margin-top: 1.2em;
		font-size: 120%
	}
	
	.dem-notice {
		z-index: 10;
		position: absolute;
		top: 0;
		border-radius: 2px;
		width: 100%;
		padding: 1.5em 2em;
		text-align: center;
		background: rgba(247, 241, 212, .8);
		color: #6d6214
	}
	
	.dem-notice-close {
		position: absolute;
		top: 0;
		right: 0;
		padding: 5px;
		cursor: pointer;
		line-height: .6;
		font-size: 150%
	}
	
	.dem-notice-close:hover {
		color: #d26616
	}
	
	.dem-star {
		font-size: 90%;
		vertical-align: baseline;
		padding-left: .3em;
		color: #ff4e00
	}
	
	.dem-poll-note {
		font-size: 90%;
		padding: .5em;
		opacity: .8;
		line-height: 1.3
	}
	
	.democracy .dem-copyright {
		position: absolute;
		bottom: -1em;
		right: 0;
		text-decoration: none;
		border-bottom: 0;
		color: #b2b2b2;
		opacity: .5;
		line-height: 1
	}
	
	.democracy .dem-copyright:hover {
		opacity: 1
	}
	
	.dem-add-answer {
		position: relative
	}
	
	.dem-add-answer>* {
		display: block
	}
	
	.dem-add-answer a {
		display: inline-block
	}
	
	input.dem-add-answer-txt {
		width: 100%;
		box-sizing: border-box
	}
	
	.dem-add-answer-close {
		position: absolute;
		right: 0;
		padding: 0 .7em;
		cursor: pointer;
		color: #333
	}
	
	.dem-add-answer-close:hover {
		color: #ff2700
	}
	
	.dem-edit-link {
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		line-height: 1;
		text-decoration: none !important;
		border: 0 !important
	}
	
	.dem-edit-link svg {
		width: 1.2em !important;
		fill: #5a5a5a;
		fill: rgba(0, 0, 0, .6)
	}
	
	.dem-edit-link:hover svg {
		fill: #35a91d
	}
	
	.dem-loader {
		display: none;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%
	}
	
	.dem-loader>* {
		display: table-cell;
		vertical-align: middle;
		text-align: center
	}
	
	.dem-loader svg {
		width: 20%;
		max-width: 100px;
		min-width: 80px;
		margin-bottom: 15%
	}
	
	.dem-loader [class^="dem-"] {
		margin-bottom: 15% !important
	}
	
	.dem__collapser {
		display: block;
		cursor: pointer;
		text-align: center;
		font-size: 150%;
		line-height: 1
	}
	
	.dem__collapser:hover {
		color: #f31;
		background: rgba(255, 255, 255, .3)
	}
	
	.dem__collapser.expanded {
		position: relative;
		height: 1em
	}
	
	.dem__collapser.collapsed {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0
	}
	
	.dem__collapser .arr {
		display: block;
		position: absolute;
		bottom: 0;
		width: 100%
	}
	
	.dem__collapser.collapsed .arr:before {
		content: "▾"
	}
	
	.dem__collapser.expanded .arr:before {
		content: "▴"
	}
	
	.dem-poll-shortcode {
		margin-bottom: 1.5em
	}
	
	.dem-archives .dem-elem-wrap {
		margin-bottom: 2em;
		padding-bottom: 20px;
		border-bottom: 1px dashed #ccc
	}
	
	.dem-archives .dem-archive-link {
		display: none
	}
	
	.dem-paging {
		text-align: center;
		margin: 1.5em auto
	}
	
	.dem-paging>* {
		display: inline-block;
		padding: .3em .8em;
		border-radius: .2em;
		background: #e2e2e2;
		color: #333;
		text-decoration: none;
		text-transform: lowercase;
		user-select: none
	}
	
	.dem-paging>a {
		color: #333
	}
	
	.dem-paging>a:hover {
		background: #ccc;
		color: #333;
		text-decoration: none
	}
	
	.dem-paging .current {
		background: #656565;
		color: #fff
	}
	
	.dem-paging .dots {
		background: none
	}
	
	.dem-link {
		font-style: italic;
		font-size: 90%
	}
	
	.dem-vote-link:before {
		content: '◂ '
	}
	
	.dem-vote label:hover {
		opacity: .8
	}
	
	.dem-vote-button {
		float: left
	}
	
	.dem-results-link {
		float: right
	}
	
	.dem-graph {
		font-family: Arial, sans-serif;
		background: #f7f7f7;
		background: linear-gradient(to bottom, rgba(0, 0, 0, .05) 50%, rgba(0, 0, 0, .1) 50%);
		background: -webkit-linear-gradient(top, rgba(0, 0, 0, .05) 50%, rgba(0, 0, 0, .1) 50%)
	}
	
	.dem-fill {
		background-image: linear-gradient(to right, rgba(255, 255, 255, .3), transparent);
		background-image: -webkit-linear-gradient(left, rgba(255, 255, 255, .3), transparent)
	}
	
	.dem-answers .dem-label {
		margin-bottom: .1em
	}
	
	.dem-votes-txt,
	.dem-percent-txt {
		font-size: 80%
	}
	
	.dem-percent-txt {
		display: none
	}
	
	.dem-answers li:hover .dem-votes-txt {
		display: none
	}
	
	.dem-answers li:hover .dem-percent-txt {
		display: table-cell
	}
	
	.dem-voted-this .dem-label:before {
		content: '✓';
		display: inline-block;
		margin-right: .2em
	}
	
	.dem-voted-this .dem-graph {
		border-color: #969696
	}
	
	.dem-label-percent-txt,
	.dem-votes-txt-percent,
	.dem-novoted .dem-votes-txt {
		display: none
	}
	
	.dem-poll-info {
		font-style: italic
	}
	
	.dem-archive-link {
		text-align: right
	}
	
	.dem-bottom {
		text-align: left
	}
	
	input[type="submit"].dem-button,
	a.dem-button,
	.dem-button {
		font-size: 90%;
		font-family: tahoma, arial, sans-serif;
		padding: .8em 1.6em !important;
		color: #fff;
		background: #61a9de;
		text-transform: uppercase
	}
	
	input[type="submit"].dem-button:hover,
	a.dem-button:hover,
	.dem-button:hover {
		color: #fff;
		background: #3b8bc6
	}
	
	a.dem-button:visited {
		color: #fff
	}
	/*###*/
	
	.dem-roller {
		margin: 0 auto;
		width: 40px;
		height: 40px;
		position: relative;
	}
	
	.con1>div,
	.con2>div,
	.con3>div {
		width: 10px;
		height: 10px;
		background-color: #2686cc;
		border-radius: 100%;
		position: absolute;
		-webkit-animation: bouncedelay 1.2s infinite ease-in-out;
		animation: bouncedelay 1.2s infinite ease-in-out;
		/* Prevent first frame from flickering when animation starts */
		-webkit-animation-fill-mode: both;
		animation-fill-mode: both;
	}
	
	.dem-roller .demrcont {
		position: absolute;
		width: 100%;
		height: 100%;
	}
	
	.con2 {
		-webkit-transform: rotateZ(45deg);
		transform: rotateZ(45deg);
	}
	
	.con3 {
		-webkit-transform: rotateZ(90deg);
		transform: rotateZ(90deg);
	}
	
	.circle1 {
		top: 0;
		left: 0;
	}
	
	.circle2 {
		top: 0;
		right: 0;
	}
	
	.circle3 {
		right: 0;
		bottom: 0;
	}
	
	.circle4 {
		left: 0;
		bottom: 0;
	}
	
	.con2 .circle1 {
		-webkit-animation-delay: -1.1s;
		animation-delay: -1.1s;
	}
	
	.con3 .circle1 {
		-webkit-animation-delay: -1.0s;
		animation-delay: -1.0s;
	}
	
	.con1 .circle2 {
		-webkit-animation-delay: -0.9s;
		animation-delay: -0.9s;
	}
	
	.con2 .circle2 {
		-webkit-animation-delay: -0.8s;
		animation-delay: -0.8s;
	}
	
	.con3 .circle2 {
		-webkit-animation-delay: -0.7s;
		animation-delay: -0.7s;
	}
	
	.con1 .circle3 {
		-webkit-animation-delay: -0.6s;
		animation-delay: -0.6s;
	}
	
	.con2 .circle3 {
		-webkit-animation-delay: -0.5s;
		animation-delay: -0.5s;
	}
	
	.con3 .circle3 {
		-webkit-animation-delay: -0.4s;
		animation-delay: -0.4s;
	}
	
	.con1 .circle4 {
		-webkit-animation-delay: -0.3s;
		animation-delay: -0.3s;
	}
	
	.con2 .circle4 {
		-webkit-animation-delay: -0.2s;
		animation-delay: -0.2s;
	}
	
	.con3 .circle4 {
		-webkit-animation-delay: -0.1s;
		animation-delay: -0.1s;
	}
	
	@-webkit-keyframes bouncedelay {
		0%,
		80%,
		100% {
			-webkit-transform: scale(0.0)
		}
		40% {
			-webkit-transform: scale(1.0)
		}
	}
	
	@keyframes bouncedelay {
		0%,
		80%,
		100% {
			transform: scale(0.0);
			-webkit-transform: scale(0.0);
		}
		40% {
			transform: scale(1.0);
			-webkit-transform: scale(1.0);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/opinion.vue